/**
 * An error carrying extra structured context for diagnostics. Thrown for "should never happen"
 * conditions that we still want to surface through the global {@link ErrorHandler} without crashing
 * the user-facing flow.
 */
export class DebugError extends Error {
  constructor(
    message: string,
    public readonly context?: unknown
  ) {
    super(message);
    this.name = 'DebugError';
  }
}
